import { Point } from 'paper'

export const shapesLayout4 = [
  {
    shape: 'blobby',
    position: new Point(5, 15),
    scale: 2.5,
    rotate: 0,
    color: 'red',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(75, -200),
      rotate: 0
    }
  },
  {
    shape: 'tilde',
    position: new Point(15, 22),
    scale: 1.1,
    rotate: -40,
    color: 'blue',
    overlay: 0
  },
  {
    inset: 'green-chili',
    position: new Point(93, 10),
    scale: 0.7,
    rotate: 0
  },
  {
    shape: 'golf_club',
    position: new Point(90, 30),
    scale: 1.5,
    rotate: 270,
    color: 'purple',
    overlay: {
      shape: 'overlay',
      scale: 1.25,
      translate: new Point(-350, 50),
      rotate: 0
    }
  },
  {
    inset: 'red-chili',
    position: new Point(90, 45),
    scale: 0.8,
    rotate: 0
  },
  {
    shape: 'droplet',
    position: new Point(5, 40),
    scale: 1,
    rotate: 80,
    color: 'yellow',
    overlay: {
      shape: 'overlay',
      scale: 0.1,
      translate: new Point(0, 0),
      rotate: 0
    }
  },
  {
    inset: 'star-anise',
    position: new Point(5, 50),
    scale: 0.5,
    rotate: 0
  },
  {
    shape: 'blob',
    position: new Point(5, 60),
    scale: 1.25,
    rotate: 0,
    color: 'brown',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(-350, -200),
      rotate: 0
    }
  },
  {
    shape: 'blobby',
    position: new Point(95, 60),
    scale: 1.5,
    rotate: 0,
    color: 'skinTone',
    overlay: 0
  },
  {
    shape: 'tilde',
    position: new Point(10, 65),
    scale: 1,
    rotate: 0,
    color: 'yellow',
    overlay: 0
  },
  {
    inset: 'tamarind',
    position: new Point(5, 75),
    scale: 1,
    rotate: 0
  },
  {
    shape: 'golf_club',
    position: new Point(90, 80),
    scale: 1.25,
    rotate: 270,
    color: 'blue',
    overlay: {
      shape: 'overlay',
      scale: 1.25,
      translate: new Point(-350, 50),
      rotate: 0
    }
  },
  {
    inset: 'rice',
    position: new Point(98, 93),
    scale: 0.75,
    rotate: 0
  },
  {
    shape: 'tilde',
    position: new Point(5, 90),
    scale: 1,
    rotate: -40,
    color: 'purple',
    overlay: {
      shape: 'overlay',
      scale: 0.75,
      translate: new Point(50, -220),
      rotate: 0
    }
  },

  {
    shape: 'smudge',
    position: new Point(8, 95),
    scale: 0.75,
    flipX: true,
    rotate: 325,
    color: 'blue',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(110, -50),
      rotate: 0
    }
  },
  {
    shape: 'boomerang',
    position: new Point(95, 98),
    scale: 2,
    rotate: 0,
    color: 'skinTone',
    overlay: 0
  }
]
